import {ApiClient} from '@adyenPWA/lib/services/api'

export class AdyenShippingMethodsService {
    baseUrl = '/api/adyen/shipping-methods'
    apiClient = null

    constructor(token, site) {
        this.apiClient = new ApiClient(this.baseUrl, token, site)
    }

    /**
     * Asynchronously retrieves shipping methods for a given basket and customer.
     *
     * @param {string} basketId - The unique identifier for the basket.
     * @param {string} customerId - The unique identifier for the customer.
     * @returns {Promise<Object>} A promise that resolves to the JSON response containing shipping methods.
     * @throws {Error} Throws an error if the API response status is 300 or greater.
     */
    async getShippingMethods(basketId, customerId) {
        const res = await this.apiClient.get({
            headers: {
                basketid: basketId,
                customerid: customerId
            }
        })
        if (res.status >= 300) {
            throw new Error(res)
        } else {
            return await res.json()
        }
    }

    /**
     * Updates the shipping method for a specified basket and customer.
     *
     * This function sends a POST request to update the shipping method associated with a given basket and customer.
     * It utilizes the `apiClient` to perform the request and handles the response accordingly.
     *
     * @async
     * @param {string} shippingMethodId - The identifier for the new shipping method to be applied.
     * @param {string} basketId - The identifier of the basket for which the shipping method is being updated.
     * @param {string} customerId - The identifier of the customer associated with the basket.
     * @returns {Promise<Object>} A promise that resolves to the JSON response object if the request is successful.
     * @throws {Error} Throws an error if the response status is 300 or greater, indicating a failed request.
     */
    async updateShippingMethod(shippingMethodId, basketId, customerId) {
        const res = await this.apiClient.post({
            body: JSON.stringify({
                shippingMethodId
            }),
            headers: {
                basketid: basketId,
                customerid: customerId
            }
        })
        if (res.status >= 300) {
            throw new Error(res)
        } else {
            return await res.json()
        }
    }
}
